import { Summary } from '../modules/MultiModelHistory/component/Summary'
import { ShipmentSummary } from '../modules/MultiModelHistory/component/ShipmentSummary'
import { Exceptions } from '../modules/MultiModelHistory/component/Exceptions'
import { Delays } from '../modules/MultiModelHistory/component/Delays'
import { OceanPortLogs } from '../modules/MultiModelHistory/component/OceanPortLogs'
import { TransporterDetails } from '../modules/MultiModelHistory/component/TransporterDetails'
import { Stoppages } from '../modules/MultiModelHistory/component/Stoppages'
import { History } from '../modules/MultiModelHistory/component/History'
import { ItemDetails } from '../modules/MultiModelHistory/component/ItemDetails'
import { PackageDetails } from '../modules/MultiModelHistory/component/PackageDetails'
import { EPOD } from '../modules/MultiModelHistory/component/EPOD'
import ParcelSummary from '../modules/ParcelHistory/components/Summary'
import ParcelEpod from '../modules/ParcelHistory/components/EPOD'
import ParcelException from '../modules/ParcelHistory/components/Exception'
import ParcelItemDetails from '../modules/ParcelHistory/components/ItemDetail'
import { Loadsensor } from '../modules/MultiModelHistory/component/Loadsensor'
import { AiCamera } from '../modules/MultiModelHistory/component/AiCamera'

interface ITripDetailConstant {
  [key: string]: string
}
export const tripDetailConstant: ITripDetailConstant = {
  routeLabel: 'Route',
  startend: 'Start & End Time',
  closureReason: 'Closure Reason',
  closedDate: 'Closed At',
  material: 'Product',
  status: 'Status',
  closureTime: 'Trip Close Time',
  startDate: 'Start Date',
  invoiceNo: 'Invoice Number',
  eta: 'ETA',
  sta: 'STA',
  overspeedInstances: 'OverSpeed',
  driverName: 'Driver Name',
  phoneNo: 'Mobile Number',
  vehicleNo: 'Vehicle Number',
  transporter: 'Transporter',
  loading: 'LOADING',
  unloading: 'UNLOADING',
  isClosed: 'Resolved',
  awaitingResolution: 'Awaiting Resolution',
  exceptions: 'Exception',
  stoppage: 'Stoppage',
  history: 'History',
  landmark: 'LandMark',
  duration: 'Duration',
  time: 'Time',
  tripDetails: 'Trip Details',
  images: 'Images',
  basicDetails: 'Details',
  startTime: 'Trip Start Time',
  epod: 'EPOD',
  referenceNo: 'Reference Number',
  closedBy: 'Closed By',
  source: 'Source',
  loadsensor: 'Loadsensor',
  documents : 'Documents',
  trackingProvider: 'Tracking Provider'
}
export const API_URL = 'https://tpt-preprod.fareye.co'
// 1- List Issues - GET /api/v1/issues
// 2-  Create Issues - POST /api/v1/issues
// 3-  List Comments - /api/v1/show_comments?id=3
// 4-  Add Comments - POST /api/v1/commontator/comments
// 5-  Unsubscribe - PUT /api/v1/commontator/subscriptions/:id/unsubscribe
// 6-  Subscribe - PUT /api/v1/commontator/subscriptions/:id/subscribe

export const Issues_Url = {
  subscribe: '/api/v1/commontator/subscriptions',
  showComments: '/api/v1/show_comments',
  addComments: '/api/v1/commontator/threads',
  issueListing: '/api/v1/issues',
  category: '/api/v1/get_issue_category',
  getUser: '/api/v1/alert_user_list',
  addUser: '/api/v1/create_alert_user'
}

export const mapComponent = {
  summary: Summary,
  shipmentSummary: ShipmentSummary,
  exceptions: Exceptions,
  delays: Delays,
  oceanPortLogs: OceanPortLogs,
  transporterDetails: TransporterDetails,
  stoppages: Stoppages,
  history: History,
  itemDetails: ItemDetails,
  packageDetails: PackageDetails,
  ePOD: EPOD,
  summaryParcel: ParcelSummary,
  parcelEpod: ParcelEpod,
  parcelException: ParcelException,
  parcelItemDetails: ParcelItemDetails,
  loadsensor: Loadsensor,
  aiCamera: AiCamera
}

export const historyCSVColumns = [
  { key: 'landmark', label: 'Landmark' },
  { key: 'gpsTimestamp', label: 'Time', formatter: 'dateFormatter' },
  { key: 'latitude', label: 'Latitude' },
  { key: 'longitude', label: 'Longitude' }
]

export const stoppageCSVColumns = [
  { key: 'startLandmark', label: 'Landmark' },
  { key: 'startTimestampUtc', label: 'Start Time', formatter: 'dateFormatter' },
  { key: 'endTimestampUtc', label: 'End Time', formatter: 'dateFormatter' },
  { key: 'durationFormat', label: 'Duration' }
]
export const InitialState = {
  isLoading: false,
  isError: false,
  isSuccess: true,
  message: '',
  data: null
}
